import Table, { type TableProps } from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import type { SxProps, Theme } from "@mui/material/styles";

interface ScrollTableProps extends TableProps {
  /** The scrolling box around the table, e.g. a `maxHeight` for a `stickyHeader`. */
  containerSx?: SxProps<Theme>;
}

/**
 * Every table in the app (a small MUI `Table`): it scrolls sideways when its
 * columns are wider than the box it sits in, so no column is cut off on a phone.
 */
export default function ScrollTable({ containerSx, size = "small", ...props }: ScrollTableProps) {
  return (
    <TableContainer sx={containerSx}>
      <Table size={size} {...props} />
    </TableContainer>
  );
}
